import { storageUsage, type StorageUsage } from '@fewerbags/core';

const rtf = new Intl.RelativeTimeFormat(undefined, { numeric: 'auto' });

export function relativeTime(iso: string, now = Date.now()): string {
  const diff = new Date(iso).getTime() - now;
  const abs = Math.abs(diff);
  const min = 60_000;
  if (abs < min) return rtf.format(Math.round(diff / 1000), 'second');
  if (abs < 60 * min) return rtf.format(Math.round(diff / min), 'minute');
  if (abs < 24 * 60 * min) return rtf.format(Math.round(diff / (60 * min)), 'hour');
  return rtf.format(Math.round(diff / (24 * 60 * min)), 'day');
}

export function shortDate(iso: string): string {
  return new Date(iso).toLocaleDateString(undefined, { dateStyle: 'medium' });
}

export function timezones(): string[] {
  try {
    const list = Intl.supportedValuesOf('timeZone');
    if (list.length) return list;
  } catch {
    // older browsers
  }
  return ['America/Los_Angeles', 'America/Denver', 'America/Chicago', 'America/New_York', 'UTC'];
}

export const ROLE_LABEL: Record<'owner' | 'adult' | 'member', string> = {
  owner: 'Owner',
  adult: 'Adult',
  member: 'Member',
};

export const EQUIPMENT_LABEL: Record<string, string> = {
  oven: 'Oven',
  burner: 'Burners',
  grill: 'Grill',
  microwave: 'Microwave',
  slow_cooker: 'Slow cooker',
  air_fryer: 'Air fryer',
  sous_vide: 'Sous vide',
};

/** "Photos: 120 MB of 2 GB" plus the bar fraction for the household storage meter. */
export function photoStorage(
  usedBytes: number,
  quotaBytes: number,
): StorageUsage & { line: string } {
  const usage = storageUsage(usedBytes, quotaBytes);
  return { ...usage, line: `Photos: ${usage.label}` };
}
